import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';

export default {
  load(membershipId) {
    const url = formUrl(`/api/v1/admin/memberships/${membershipId}/payments`);

    return FetchHelpers.get(url);
  },

  create(membershipId, params) {
    const url = formUrl(`/api/v1/admin/memberships/${membershipId}/payments`);

    return FetchHelpers.post(url, params);
  },

  delete(membershipId, paymentId) {
    const url = formUrl(
      `/api/v1/admin/memberships/${membershipId}/payments/${paymentId}`
    );

    return FetchHelpers.delete(url);
  },
};
